import { StrictMode } from "react";
import "react-bootstrap-typeahead/css/Typeahead.css";
import ReactDOM from "react-dom";
import App from "./App";
import "./index.css";
import { initializeTelemetry } from "./telemetry";

const params = new URLSearchParams(window.location.search);
const is_telemetry_enabled = params.get("enable_telemetry");
if (is_telemetry_enabled === "false") {
  window.MERGE_LINK_TELEMETRY = "off";
} else if (is_telemetry_enabled === "true") {
  window.MERGE_LINK_TELEMETRY = "on";
}

initializeTelemetry();

let informationalMessage = null;
if (process.env.NODE_ENV === "development" && window.location === window.parent.location) {
  informationalMessage =
    process.env.REACT_APP_MERGE_ENV === "PRODUCTION" ? (
      <>
        <h1>You got merge-link running! [PRODUCTION]</h1>
        <p>
          Run <code> yarn start-example-prod</code> and visit localhost:3006 to see local merge-link
          frontend run against prod backend
        </p>
      </>
    ) : (
      <>
        <h1>You got merge-link running!</h1>
        <p>
          Run <code>yarn start-example-local</code> or any of the other examples to start testing
          the linking flow on port 3006
        </p>
      </>
    );
}
ReactDOM.render(
  <StrictMode>
    {informationalMessage}
    <App />
  </StrictMode>,
  document.body
);
